module.exports = __webpack_public_path__ + "static/media/astronauta_2.7821c8ed.svg";